import { Point } from 'google-map-react'

import { HomeGroups } from '../DisplayCity/DisplayCity'

export namespace GeoLocation {
  export namespace GET_GEOLOCATION_HOMES {
    export type Response = Homes_API_Response
    export type Error = unknown
  }

  export namespace GET_GEOLOCATION_PROPERTIES {
    export type Response = Property_API_Response
    export type Error = unknown
  }

  export function getGeoLocationHomes() {
    return { url: '/api/v1/homes.json' }
  }

  export function getGeoLocationProperties() {
    return { url: '/api/v1/properties.json' }
  }
}

export interface Homes_API_Response {
  data: HomesAPI_Data
}

export interface HomesAPI_Data {
  current_page: number
  home_groups?: HomeGroups
  homes_count: number
  results_per_page: number
  total_homes: number
  total_pages: number
}

export interface Property_API_Response {
  data: {
    properties: Property[]
  }
}

export interface Property {
  address: string
  amenities: string[]
  display_name: string
  has_favorites: boolean
  homes?: []
  id: number
  image_url: string
  landing_direct: boolean
  latitude: string
  longitude: string
  mapProperty?: {
    inCenterHalf: boolean
    position?: Point
    quadrant: {
      east?: boolean
      north?: boolean
      south?: boolean
      west?: boolean
    }
  }
  name: string
  property_images: string[]
  slug: string
  street: string
}
